import { Link } from 'react-router-dom';
import TopicCard from '@/components/feature/TopicCard';
import { topics } from '@/mocks/topics';

export default function HotTopicsSection() {
  const list = topics.slice(0, 6);

  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="w-full px-4 py-14 md:px-8 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-primary-600">Trending Topics</p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              正在热议的话题
            </h2>
          </div>
          <Link
            to="/topics"
            className="whitespace-nowrap border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            查看全部话题 <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((topic, index) => (
            <TopicCard key={topic.id} topic={topic} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}